import styled from "styled-components";

export const Width = {
  wPhone: "100%",
  wTablet: "1024px",
  wDestop: "1320px",
};

export const FullView = styled.div`
  min-width: 102vw;
  position: relative;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  &.fullEscudos {
    background: #151e24;
  }
`;
